import i18n from "../../../../config/locale/i18n";
import {
  CRITICAL,
  MEDIUM,
  INFORMATIONAL,
  HIGH,
  LOW,
} from "../../../../utils/app-constants.json";

export const FBP_NOTIFICATION_KEYS = {
  ACCOUNTNUMBER: "AccountNumber",
  REGIONCODE: "RegionCode",
  SNS_TOPIC: "SNSTopic",
  SEVERITY_LEVEL: "Severity",
};

export const SecurityHubSeverityOptions = [
  {
    label: i18n.t("common:critical"),
    value: CRITICAL,
  },
  {
    label: i18n.t("common:high"),
    value: HIGH,
  },
  {
    label: i18n.t("common:medium"),
    value: MEDIUM,
  },
  {
    label: i18n.t("common:low"),
    value: LOW,
  },
  {
    label: i18n.t("common:informational"),
    value: INFORMATIONAL,
  },
];

export const GuardDutySeverityOptions = [
  {
    label: i18n.t("common:high"),
    value: HIGH,
  },
  {
    label: i18n.t("common:medium"),
    value: MEDIUM,
  },
  {
    label: i18n.t("common:low"),
    value: LOW,
  },
];

export const serviceIds = {
  ControlTower: "ControlTower",
  CloudTrail: "CloudTrail",
  SecurityHub: "SecurityHub",
  GuardDuty: "GuardDuty",
};

export const serviceLinks = {
  ControlTower: "https://aws.amazon.com/controltower/",
  CloudTrail: "https://aws.amazon.com/cloudtrail/",
  SecurityHub: "https://aws.amazon.com/security-hub/",
  GuardDuty: "https://aws.amazon.com/guardduty/",
};

export const fbpserviceList = [
  {
    id: serviceIds.ControlTower,
    link: serviceLinks.ControlTower,
    title: "AWS Control Tower",
    description:
      "AWS Control Tower simplifies set up and governance of secure, multi-account AWS Environments.",
    icon: "ControlTowerBg",
    noBgIcon: "ControlTower",
    configureHeading:
      "Select the AWS Accounts that you manage via AWS Control Tower",
    scanItems: [
      {
        key: "isControlTowerEnabled",
        check:
          "AWS Control Tower Landing Zone set up must be configured in the Management account",
        positiveFinding: "AWS Control Tower Landing Zone set up is configured",
        negativeFinding:
          "AWS Control Tower Landing Zone set up is not configured",
        remediation: "CONFIGURE_CONTROL_TOWER_ON_AWS",
      },
      {
        key: "ControlTowerHomeRegion",
        check: "AWS Control Tower home region must be set",
        positiveFinding: "AWS Control Tower home region is set",
        negativeFinding: "AWS Control Tower home region is not set",
        remediation: "CONFIGURE_CONTROL_TOWER_ON_AWS",
      },
      {
        key: "ControlTowerAuditAccountNumber",
        check: "Audit account for AWS Control Tower must be set",
        positiveFinding: "Audit account for AWS Control Tower is set",
        negativeFinding: "Audit account for AWS Control Tower is not set",
        remediation: "CONFIGURE_CONTROL_TOWER_ON_AWS",
      },
      {
        key: "ControlTowerLogAccountNumber",
        check: "Log account for AWS Control Tower must be set",
        positiveFinding: "Log account for AWS Control Tower is set",
        negativeFinding: "Log account for AWS Control Tower is not set",
        remediation: "CONFIGURE_CONTROL_TOWER_ON_AWS",
      },
      {
        key: "IsControlTowerAuditAccountOnboarded",
        check: "Audit account must be connected with MontyCloud DAY2™",
        positiveFinding: "Audit account is connected with MontyCloud DAY2™",
        negativeFinding: "Audit account is not connected with MontyCloud DAY2™",
        remediation: "CONNECT_AWS_ACCOUNT",
      },
      {
        key: "IsControlTowerLogAccountOnboarded",
        check:
          "Log account must be connected with connected with MontyCloud DAY2™",
        positiveFinding: "Log account is connected with MontyCloud DAY2™",
        negativeFinding: "Log account is not connected with MontyCloud DAY2™",
        remediation: "CONNECT_AWS_ACCOUNT",
      },
      {
        key: "ControlTowerManagedAccounts",
        check: "Select AWS Control Tower managed accounts",
        positiveFinding: "AWS Control Tower managed accounts are selected",
        negativeFinding: "AWS Control Tower managed accounts are not selected",
        remediation:
          "Select AWS Control Tower managed accounts in the configure step",
      },
      {
        key: "ControlTowerManagedRegions",
        check: "Select AWS Control Tower managed regions",
        positiveFinding: "AWS Control Tower managed regions are selected",
        negativeFinding: "AWS Control Tower managed regions are not selected",
        remediation:
          "Select AWS Control Tower managed regions in the configure step",
      },
    ],
    configure: [
      {
        key: "ManagedAccounts",
        label: "Select the AWS Accounts that you manage via AWS Control Tower",
        type: "AccountPicker",
        defaultValue: [],
      },
      {
        key: "ManagedRegions",
        label: "Select the AWS Regions that you manage via AWS Control Tower",
        type: "RegionPicker",
        defaultValue: [],
      },
    ],
    content: {
      name: "AWS Control Tower",
      description:
        "AWS Control Tower simplifies set up and governance of secure, multi-account AWS Environments. It orchestrates multiple AWS services on your behalf, while maintaining your organization’s security and compliance requirements. AWS Control Tower offers:​",
      messages: [
        "A centralized and automated solution for managing multi-account AWS environments.​",
        "Simplified provisioning of new AWS accounts with built-in governance, best practices, standards and regulatory requirements.​",
        "Centralized logging and monitoring capabilities streamline troubleshooting and auditing processes.​",
        "Helps enforce Security configurations, implement preventive, detective and proactive measures.​",
      ],
      guide: {
        heading:
          "MontyCloud DAY2™ helps you verify if AWS Control Tower is configured with best practices. From a single interface you can perform this action for multiple AWS Management Accounts. If you manage multiple customers (tenants) you can easily switch between tenants and complete the configuration.​",
        messages: [
          "Detect the status of your AWS Control Tower configuration and help you configure it if needed.​",
          "Identify and select your Control Tower home region, Audit and Log Accounts.​",
          "Select your AWS Control Tower Managed Account(s) and Region(s) and complete the configuration.​",
        ],
      },
    },
  },
  {
    id: serviceIds.CloudTrail,
    link: serviceLinks.CloudTrail,
    title: "AWS CloudTrail",
    description:
      "AWS CloudTrail records, monitors, and analyzes account activity across all your AWS infrastructure.",
    icon: "CloudTrailBg",
    noBgIcon: "CloudTrail",
    findingsRemediation: {
      Failed:
        "Deploy an organization-trail following the SRA specification in the configure step.",
      Error: "Fix the error",
    },
    configureHeading: "Choose Log Events",
    configureHelptext:
      "Choose the type of events that you want to log. Enabling management events will help capture management operations performed on your AWS Resources. Enabling data events will help log the resource operations performed on or within a resource.",
    configure: [
      {
        key: "EnableManagementEvents",
        label: "Enable Management Events",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableLambdaEvents",
        label: "Enable Lambda Events",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableS3DataEvents",
        label: "Enable S3 Data Events",
        type: "checkbox",
        defaultValue: true,
      },
    ],
    content: {
      name: "AWS CloudTrail",
      description:
        "AWS CloudTrail records, monitors, and analyzes account activity across all your AWS infrastructure.​",
      messages: [
        "Records and provides detailed logs and audit trails for all API calls and activities within your AWS account.​",
        "Enables centralized visibility and monitoring of account activity, helps you track changes, troubleshoot issues, and enhance security.​",
        "Helps you easily investigate security incidents, analyze operational issues, and meet compliance requirements.​",
      ],
      guide: {
        heading:
          "MontyCloud DAY2™ helps you setup and configure AWS CloudTrail across your Multi-Accounts and Cross-region Cloud footprint.From a single interface you can create an organization trail, setup encryption using your Keys, select key events to be recorded, and protect from accidental misconfigurations by members accounts.",
        messages: [
          "Detect if an Organization Trail is already present, if not help enable it for all the AWS Accounts and Regions you choose.​",
          "Choose a customer-managed key (CMK) using which we can setup encryption for your logs.",
          "Enable Management and Data Events for services such as Amazon S3,  AWS Lambda etc., and configure protections. ​",
        ],
      },
    },
  },
  {
    id: serviceIds.SecurityHub,
    link: serviceLinks.SecurityHub,
    title: "AWS Security Hub",
    description:
      "AWS Security Hub is a cloud security posture management service that consumes, aggregates, organizes and prioritizes security findings.",
    icon: "SecurityHubBg",
    noBgIcon: "SecurityHub",
    findingsRemediation: {
      Failed:
        "Configure Security Hub in the Audit account as per the recommendations in configure step.",
    },
    configureHeading: "Configure Security Hub Standards",
    configureHelptext:
      "Enabling AWS Security Hub grants its permissions to configure security checks",
    configure: [
      {
        key: "AWSFoundationalSecurityBestPracticesv1.0",
        label: "Enable AWS Foundational Security Best Practices v1.0.0",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "CISAWSFoundationsBenchmarkv1.2",
        label: "Enable CIS AWS Foundations Benchmark v1.2.0",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "CISAWSFoundationsBenchmarkv1.4",
        label: "Enable CIS AWS Foundations Benchmark v1.4.0",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "NISTSpecialPublication800-53Revision5",
        label: "Enable NIST Special Publication 800-53 Revision 5",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "PCIDSSv3.2.1",
        label: "Enable PCI DSS v3.2.1",
        type: "checkbox",
        defaultValue: true,
      },
    ],
    content: {
      name: "AWS Security Hub",
      description:
        "AWS Security Hub is a cloud security posture management service that consumes, aggregates, organizes and prioritizes security findings from AWS services and third-party product integrations.",
      messages: [
        "Centralized security visibility and management for AWS resources.",
        "Automated continuous monitoring of security and compliance checks.​",
        "Prioritized and actionable security findings and recommendations.​",
      ],
      guide: {
        heading:
          "MontyCloud DAY2™ helps you setup and configure AWS Security Hub across your both your AWS Organization accounts and any future AWS Organization account that you use.  In a single interface you can now synchronize security standards across all AWS accounts and regions managed by AWS Control Tower.​",
        messages: [
          "Choose the home region for consolidating security findings.​",
          "Configure delegated administrator privileges to centralize security posture management.​",
          "Enable/Disable Security Hub standards for any AWS accounts and regions connected with MontyCloud.​",
        ],
      },
    },
  },
  {
    id: serviceIds.GuardDuty,
    link: serviceLinks.GuardDuty,
    title: "Amazon GuardDuty",
    description:
      "Amazon GuardDuty is an intelligent threat detection service. It continuously monitors your AWS accounts and workloads for malicious activity.",
    icon: "GuardDutyBg",
    noBgIcon: "GuardDuty",
    findingsRemediation: {
      Failed:
        "Configure Guard Duty in the Audit account as per the recommendations in configure step.",
      Error: "Fix the error",
    },
    configureHeading: "Configure",
    configureHelptext:
      "Enabling protection for the mentioned services enhances security by efficiently detecting and mitigating threats, safeguarding the integrity and confidentiality of data stored in Amazon S3 buckets from potential attacks.",
    configure: [
      {
        key: "EnableS3Protection",
        label: "Enable S3 Protection",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableEKSProtection",
        label: "Enable EKS Protection",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableMalwareProtection",
        label: "Enable Malware Protection",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableRDSProtection",
        label: "Enable RDS Protection",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "EnableLambdaProtection",
        label: "Enable Lambda Protection",
        type: "checkbox",
        defaultValue: true,
      },
      {
        key: "FindingPublishingFrequency",
        label:
          "Select interval to automatically export findings to your AWS Log account’s S3 Bucket",
        type: "select",
        values: [
          {
            label: "15 minutes",
            value: "FIFTEEN_MINUTES",
          },
          {
            label: "1 hour",
            value: "ONE_HOUR",
          },
          {
            label: "6 hours",
            value: "SIX_HOURS",
          },
        ],
        defaultValue: "FIFTEEN_MINUTES",
      },
    ],
    content: {
      name: "Amazon GuardDuty",
      description:
        "Amazon GuardDuty is an intelligent threat detection service. It continuously monitors your AWS accounts and workloads for malicious activity. Maintain a constant surveillance of your AWS accounts, instances, serverless and container workloads, users, databases, and storage to identify and mitigate potential security risks.​",
      messages: [
        "Machine Learning powered continuous monitoring and detection of potential security threats in your AWS environment​",
        "Real-time alerts to notify you of potential security incidents, enabling you to take immediate action.​​",
        "Deep visibility into detected threats, including their severity, affected resources, and recommended remediation steps.​​",
      ],
      guide: {
        heading:
          "MontyCloud DAY2™ helps you setup and configure Amazon GuardDuty across your both your AWS Organization account and any future AWS Organization account that you use.  You can manage the scope of coverage of GuardDuty, configure encryption and export options for GuardDuty findings to store in S3.​",
        messages: [
          "Enable GuardDuty for Control Tower Managed Account(s) and Region(s).​",
          "Configure delegated administrator privileges for the Audit account you choose.​",
          "Create or choose a customer-managed key (CMK) using which you can encrypt GuardDuty findings that are stored in S3.​",
        ],
      },
    },
  },
];

export const PASSED_STATUS = "Passed";
export const FAILED_STATUS = "Failed";
export const ERROR_STATUS = "Error";
export const CONFIGURED_STATUS = "Configured";
export const NEEDS_ATTENTION_STATUS = "Needs Attention";
export const NOT_CONFIGURED_STATUS = "Not Configured";

export const RUNNING_SERVICE_STATUS = "RUNNING";
export const CONFIGURED_SERVICE_STATUS = "CONFIGURED";
export const PENDING_SERVICE_STATUS = "PENDING";
export const UNKOWN_SERVICE_STATUS = "UNKNOWN";

export const RUNNING_SCAN_STATUS = "running";
export const COMPLETED_SCAN_STATUS = "completed";
export const PENDING_SCAN_STATUS = "pending";
export const UNKOWN_SCAN_STATUS = "unknown";
export const NEEDS_ATTENTION_SCAN_STATUS = "needs_attention";
export const CONFIGURED_SCAN_STATUS = "configured";

export const ACTION_TYPES = {
  SETUP: "SETUP",
  EDIT: "EDIT",
};

export const CONFIGURE_CONTROL_TOWER_ON_AWS = "CONFIGURE_CONTROL_TOWER_ON_AWS";
export const CONNECT_AWS_ACCOUNT = "CONNECT_AWS_ACCOUNT";

export const IS_CONTROL_TOWER_ENABLED = "isControlTowerEnabled";
